<ion-row
  class="sis-tenant-title-small"
  [ngStyle]="
    mobileStyleTenant
      ? {
          color: config?.tenantTitleColor,
          background: config?.tenantColor,
        }
      : {}
  "
>
<ion-col>
  {{ tenantAlias }}
</ion-col>
</ion-row>
@for (item of items; track trackByItemGuid($index, item)) {
  <sis-sismedia-item
    [item]="item"
    [bigScreenMode]="false"
    [config]="config"
    [mobileStyleTenant]="mobileStyleTenant"
    [longestLabelLength]="longestLabelLength"
  ></sis-sismedia-item>
}
